import React from "react";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { IoMdArrowRoundBack } from "react-icons/io";
import { HiOutlineMenu } from "react-icons/hi";
import "./navBar.css";
import "./goBackButton.css";

const NavBar = ({
  goBack,
  localizedText,
  theme,
  collapsedNavBar,
  setCollapsedNavBar,
}) => {
  return (
    <div className="nav-bar-div">
      {window.location.pathname !== "/dashboard" ? (
        <Button className={"go-back-button layout-sticky"} onClick={goBack}>
          <IoMdArrowRoundBack className="arrow"></IoMdArrowRoundBack>
          {localizedText["back"]}
        </Button>
      ) : (
        <div></div>
      )}
      <Link to="/dashboard" className="nav-bar-title">
        <img
          className="navbar-img"
          src={"/themes/" + theme + "/logo.png"}
          alt="Logo"
        />
        <div> {process.env.REACT_APP_TITLE}</div>
      </Link>

      <HiOutlineMenu
        className="expand-button"
        onClick={() => {
          setCollapsedNavBar(!collapsedNavBar);
        }}
      />
    </div>
  );
};

export default NavBar;
